export const domains = [
  {
    id: 'd1',
    url: 'https://www.heiliaowang.com',
    status: 'active',
    label: '主域名',
    updatedAt: '2026-08-07',
    description: '黑料网官方主域名，推荐首选访问地址，稳定可靠',
  },
  {
    id: 'd2',
    url: 'https://www.heiliaowang.net',
    status: 'active',
    label: '备用域名',
    updatedAt: '2026-08-06',
    description: '黑料网备用域名，主域名不可用时自动切换',
  },
  {
    id: 'd3',
    url: 'https://www.heiliaowang.org',
    status: 'active',
    label: '镜像域名',
    updatedAt: '2026-08-05',
    description: '黑料网镜像域名，全球CDN加速，访问更流畅',
  },
  {
    id: 'd4',
    url: 'https://www.heiliaowang.cn',
    status: 'active',
    label: '国内域名',
    updatedAt: '2026-08-04',
    description: '黑料网国内专属域名，国内用户访问速度更快',
  },
  {
    id: 'd5',
    url: 'https://www.hlw666.com',
    status: 'active',
    label: '新域名',
    updatedAt: '2026-08-07',
    description: '黑料网最新注册域名，防封锁长效稳定',
  },
  {
    id: 'd6',
    url: 'https://www.hlw888.vip',
    status: 'active',
    label: 'VIP域名',
    updatedAt: '2026-08-03',
    description: '黑料网VIP专属域名，尊享高速通道',
  },
];

export const domainStats = {
  totalDomains: 12,
  activeDomains: 6,
  lastUpdated: '2026-08-07',
  uptime: '99.9%',
};